<template>
  <div id="body">
    <home-header></home-header>

    <base-card>
        <div id="element-to-convert" v-if="student && !loading">
          <!-- School Code Warning -->
          <div v-if="student.school_code == 5000" 
               class="school-warning-alert">
            <div class="warning-icon">⚠️</div>
            <div class="warning-message">
              <strong>IMPORTANT NOTICE:</strong> You typed in a school that is not in the system. 
              Kindly call to have this rectified for you to be correctly placed in your institution.
            </div>
          </div>
          
          <div class="row">
            <div class="col-lg-3">
              <img width="300" height="150" src="../../assets/ng-cdflogo.jpg" />
            </div>

            <div class="col-lg-9">
              National Government Constituency Development Fund
              <br />
              North Mugirango constituency,
              <br />
              D.C.C Office Building, Ekerenyo, Nyamira county
              <br />
              Email: ngcdfnorthmugirango@ngcdf.go.ke Website: www.cdf.go.ke
            </div>
          </div>
          <small>
            <small> 
            <p>
                
             <b class="text-primary fst-italic">FORM SERIAL NUMBER:  H{{ student.id }} </b> 
               
            </p>  </small> 
          </small>
          <center>
            <b class="text-danger text-center">
             2025/26 Bursary Application form for Secondary schools
            </b>
            <br>
            <b class="text-secondary text-center"> When submitting, remain with a copy and ensure you sign and inidcate your form serial number </b>
          </center>
          ................................................................................................................................................................................................................................................................
       <br>

          <b class="text-danger">STUDENT DETAILS</b>
          <div class="row">
            <div class="col-lg-5">
              Student name:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.studentName }}
                </p>
              </div>
            </div>

            <div class="col-lg-3">
              Birth certificate:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.idNumber }}
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              Main contact phone:
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.main_contact_number }}
                </p>
              </div>
            </div>
          </div>
          
          <div class="row">
            <div class="col-lg-5">
              Sub location
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.sub_location }}
                </p>
              </div>
            </div>

            <div class="col-lg-3">
              ward
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.ward }}
                </p>
              </div>
            </div>
            <div class="col-lg-4">
              Needy status:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.needy_status }}
                </p>
              </div>
            </div>
           
          </div>

          <div class="row">
            <div class="col-lg-5">
              Institution Name:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.schoolName }}
                </p>
              </div>
            </div>

            <div class="p col-lg-3">
              School type
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.school_type }}
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              Year of Admission
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.yearofadmission }}
                </p>
              </div>
            </div>
         
          </div>

          <div class="row">
            <div class="col-lg-5">
              Admission number:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.adminNumber }}
                </p>
              </div>
            </div>

            <div class="p col-lg-3">
              Class
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.student_form }}
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              Dissability status
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.disability_status }}
                </p>
              </div>
            </div>
         
          </div>

          <!-- <b class="text-danger">Insitution Details</b> -->

          <div class="row"></div>
          <div class="row"></div>
          <b class="text-danger">PARENT DETAILS</b>

          <div class="row">
            <div class="col-lg-5">
              Mother name:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.mother_names }}
                </p>
              </div>
            </div>

            <div class="col-lg-3">
              Mother Id:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.mother_id }}
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              Mother year of Birth:
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.mother_yob }}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5">
              Father names:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.father_names }}
                </p>
              </div>
            </div>

            <div class="col-lg-3">
              Father Id:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.father_id }}
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              Father year of Birth:
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.father_yob }}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-5">
              Guardian Names:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.guardian_name }}
                </p>
              </div>
            </div>

            <div class="col-lg-3">
              Guardian Id:
              <div>
                <p class="text-capitalize text-primary">
                  {{ student.guardian_id }}
                </p>
              </div>
            </div>

            <div class="col-lg-4">
              Guardian year of Birth:
              <div class="typed">
                <p class="text-capitalize text-primary">
                  {{ student.guardian_yob }}
                </p>
              </div>
            </div>
          </div>
          <div class="row">
              <div class="col">Occupation and narration
              <div class="col typed">
                <p class=" text-primary">
                   {{ student.occupation }}
                </p>
              </div>
            </div>
            </div>
         
          <br />
          <!-- <div class="html2pdf__page-break"></div> -->
          <div class="p1">
            <b> Attach the following documents:</b>
            <br />
            1. Student's report form
            <br />
            2. Photocopy of parent/guardian's ID card
            <br />
            3. Photocopy of Student's National ID/Birth certificate
    
            <br />
            4. School/ institution admission
            <br />
          
          </div>

          <div>
            <p class="text-danger">CHIEF/ASS. CHIEF</p>
            <p>
              Kindly help us verify the information given by the student. Your
              honest remarks will help in disbursing bursaries to needy students
              within our consituency since you know the student and the family
              better
            </p>

            <br />
            <div class="row">
              <div class="col-lg-6">
                Name: .......................................................................................
              </div>
              <div class="col-lg-6">Official stamp:</div>
              <br />
              <br />
            </div>
            <div class="row">
              <br />
              <br />
              <div class="col-lg-6">
                Remarks: ....................................................................................
              </div>
              <div class="col-lg-6">
                Signature: ..........................................................
              </div>
            </div>
          </div>
       

          <b> For official use only</b>
         
          <div class="row">
            <div class="col-lg-6">Approved By NG-CDF Committee</div>
            <br />
            <div class="col-lg-6">
              Amount Awarded: ......................................
            </div>
          </div>
          <br />
          <div class="row">
            <div class="col-lg-6">
              Name: .........................................................................
            </div>
           
            <br />
            <div class="col-lg-6">
              signature and stamp: .......................................................
            </div>
          
          </div>
       
        </div> <!-- End of element-to-convert -->

        <!-- Loading State -->
        <div v-if="loading" class="loading-state">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p>Loading student information...</p>
        </div>

        <!-- Error State -->
        <div v-if="error" class="error-state">
          <div class="alert alert-danger">
            <strong>Error:</strong> {{ error }}
          </div>
          <router-link to="/" class="btn btn-secondary">Go back home</router-link>
        </div>
      </base-card>

      <div class="row" v-if="!loading && !error">
        <div class="col">
          <button class="btn btn-primary" @click="exportToPDF">Download form</button>
        </div>
        <div class="col">
          <router-link to="/"> Go back home</router-link>
        </div>
      </div>
    </div>
</template>

<script>
import html2pdf from "html2pdf.js";
import axios from "axios";

export default {
  data() {
    return {
      student: null,
      loading: false,
      error: null
    };
  },
  methods: {
    exportToPDF() {
      var element = document.getElementById("element-to-convert");
      html2pdf(element, {
        margin: [5, 15, 10, 15], //top, left, buttom, right
        filename: (this.student.idNumber || this.$route.params.id) + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: {
          dpi: 192,
          scale: 2,
          logging: true,
          letterRendering: true,
        },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      });
    },
    async fetchStudent() {
      this.loading = true;
      this.error = null;
      
      try {
        const idNumber = this.$route.params.id;
        const response = await axios.get(`https://api.roberms.com/nyamoko/get/secondary/student/${idNumber}`);
        
        console.log("Full API response:", response);
        console.log("Response data:", JSON.stringify(response.data, null, 2));
        
        // Try the most common patterns
        if (response.data && Array.isArray(response.data) && response.data.length > 0) {
          this.student = response.data[0];
        } else if (response.data && response.data.data) {
          // If data is nested in a data property
          const data = response.data.data;
          if (Array.isArray(data) && data.length > 0) {
            this.student = data[0];
          } else if (typeof data === 'object') {
            this.student = data;
          }
        } else if (response.data && typeof response.data === 'object') {
          this.student = response.data;
        } else {
          this.error = "Student not found or invalid response format";
        }
        
      } catch (error) {
        console.error("API Error:", error);
        this.error = "Error fetching student data. Please try again.";
        if (error.response && error.response.status === 404) {
          this.error = "Student not found with ID: " + this.$route.params.id;
        }
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    this.fetchStudent();
  },
  watch: {
    '$route.params.id': {
      handler() {
        this.fetchStudent();
      }
    }
  }
};
</script>

<style scoped>
#body {
  width: 98vw;
  /* height: 100vw; */
  /* background-color: #eaf8d0c9; */
  position: absolute;
  margin-top: 1px;
  left: 20px;
  z-index: 999;
  justify-content: center;
  align-items: center;
}
p {
    font-size: 12px;
    color: #502c31;
    padding: 1px;
    margin: 1px;
  }
  
  p1 {
    font-size: 13px;
    color: #502c31;
    padding: 0px;
    margin: 2px;
  }
  
  div {
    font-size: 13px;
    color: #502c31;
  }

  /* School Warning Alert Styles */
  .school-warning-alert {
    background-color: #fee;
    border: 2px solid #f00;
    border-radius: 5px;
    padding: 10px 15px;
    margin-bottom: 15px;
    display: flex;
    align-items: center;
    color: #900;
    font-size: 14px;
  }

  .warning-icon {
    font-size: 20px;
    margin-right: 10px;
    flex-shrink: 0;
  }

  .warning-message {
    flex: 1;
  }

  .warning-message strong {
    color: #c00;
  }

  /* Loading and Error States */
  .loading-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 50px;
    text-align: center;
  }

  .error-state {
    padding: 20px;
    text-align: center;
  }

  .error-state .alert {
    margin-bottom: 20px;
  }

  @media print {
    .school-warning-alert {
      break-inside: avoid;
      background-color: #fee !important;
      -webkit-print-color-adjust: exact;
    }
    
    /* Hide loading/error states and buttons in print */
    .loading-state, .error-state, .btn, router-link {
      display: none !important;
    }
  }
</style>